import { auth } from "./auth";
import { appStore } from "./app-store";
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
import Config from "./config";

class Sso {    

	navigateProvider(provider, newTab = true, relayState = null) {
		Config.loadConfig().then( response => {
			let url = Config.ssoUrl;
			url = url + "?samlSource=payor&provider="+provider;
		    if ( relayState ) {
				if ( !Sso.isUrlEncoded(relayState) ) {
                  relayState = encodeURIComponent(relayState);
				}
				url = url + "&RelayState="+relayState;
			}
			
			if ( window.location.hostname === 'localhost' ) {
				url = url + "&jwt="+auth.accessToken;
			}
			
			if ( Sso.tokenExpired() ) {
				window.fetch(Sso.getAppRefreshUrl()).then( response => {
					Sso.navigate(url, newTab);
				});
			} else {
				Sso.navigate(url, newTab);		
			}
		})
	}	
	
	navigateUrl(url, newTab = true) {
		if ( Sso.tokenExpired() ) {
				window.fetch(Sso.getAppRefreshUrl()).then( response => {
					Sso.navigate(url, newTab);
				});
			} else {
				Sso.navigate(url, newTab);		
			}
	}

	static getAppRefreshUrl() {
		return `/api/app?clientDashboardId=${encodeURIComponent(appStore.clientDashboardId || 0)}`;
	}

	static isUrlEncoded(url) {
		try {
			const decodedUrl = decodeURIComponent(url);
			return decodedUrl !== url || url.includes('%');
		} catch (e) {
			return true;
		}
	} 
	
	static navigate(url, newTab) {	
		let navigationUrl = new URL(url);
		navigationUrl.search += `${navigationUrl.search ? "&" : "?"}clientDashboardId=${encodeURIComponent(appStore.clientDashboardId || 0)}`;
		url = navigationUrl.href;
		Sso.setCookie(url);
		let tab = newTab?"_blank":"_self";
		window.open(url, tab, "noreferrer");
	}
	
	static tokenExpired() {
		let now = Date.now() / 1000;
		let id = auth.accessToken;
		let token = id.accessToken;
		if ( token ) {
			let idToken = jwt_decode(token);	
			if (idToken.exp < now) {
				return true;
			}
		}
		
		return false;
	}
	
	static setCookie(url) {
		let token = auth.accessToken;
		var expire = new Date();
		var minutes = 5;
		expire.setTime(expire.getTime() + (minutes * 60 * 1000));
		
		
		let upperleveldomain = window.location.hostname;
		var parts = upperleveldomain.split('.');				
		
		if ( parts.length>3 ) {
			parts.shift();
			upperleveldomain = '.'+parts.join('.');
		}	
		
		var ssoUrl = new URL(url);
		var cookiePath = ssoUrl.pathname;
		if ( cookiePath.split("/").length>1 ) {
			cookiePath = "/"+cookiePath.split("/")[1];
	    }

		//cleanup any old cookies
		Cookies.remove("saml-token", { domain: upperleveldomain, path: cookiePath})
		Cookies.remove('samlSource', { domain: upperleveldomain, path: cookiePath })
		
		//set latest token
		Cookies.set("saml-token", token, { domain: upperleveldomain, path: cookiePath, secure: true, sameSite: 'none', expires: expire});	
		Cookies.set('samlSource', 'payor', { domain: upperleveldomain, path: cookiePath, secure: true, sameSite: 'none', expires: expire});
	}    
}

export const sso = new Sso();